import { Constants } from './types';

export default {
  MIN_AGE: 18,
  MAX_AGE: 65,
  MIN_INCOME: 1,
  MAX_INCOME: 1000000,
  CURRENCY: 'currency',
  CURRENCY_SYMBOL: '£',
  PERCENTAGE_SYMBOL: '%',
  PERCENTAGE: 'percentage',
  DATE_FORMAT: 'DD/MM/YYYY',
  INPUT_TYPES: {
    RADIO: 'radio',
    DATE: 'date',
    SELECT: 'select',
    INPUT: 'input',
    SLIDER: 'slider',
  },
  PAY_FREQUENCIES: [{
    value: 365,
    text: 'Daily',
    single: 'daily',
  }, {
    value: 52,
    text: 'Weekly',
    single: 'weekly',
  }, {
    value: 12,
    text: 'Monthly',
    single: 'monthly',
  }, {
    value: 1,
    text: 'Annually',
    single: 'annual',
  }],
} as Constants;
